import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, tone = "dark" }) => (
  <div className="flex items-center gap-4">
    <span
      className={`font-mono2 text-xs tracking-[0.3em] ${
        tone === "dark" ? "text-[#F2824F]" : "text-[#C14A15]"
      }`}
    >
      {number}
    </span>
    <span className="hairline-gold w-12" aria-hidden="true" />
    <span
      className={`font-mono2 text-xs uppercase tracking-[0.3em] ${
        tone === "dark" ? "text-slate-400" : "text-[#5D6779]"
      }`}
    >
      {label}
    </span>
  </div>
);

const GhostNumeral = ({ number }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [64, -64]);
  return (
    <motion.span
      ref={ref}
      style={{ y }}
      data-testid={`section-ghost-${number}`}
      aria-hidden="true"
      className="ghost-numeral pointer-events-none absolute -left-2 -top-20 text-[6rem] sm:-left-4 sm:-top-28 sm:text-[9rem] lg:-top-36 lg:text-[11rem]"
    >
      {number}
    </motion.span>
  );
};

export const SectionHeading = ({
  number,
  label,
  title,
  className = "",
  tone = "dark",
}) => (
  <Reveal className={`relative ${className}`}>
    <GhostNumeral number={number} />
    <div className="relative">
      <Chapter number={number} label={label} tone={tone} />
      <h2
        className={`font-display mt-6 text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl ${
          tone === "dark" ? "text-slate-100" : "text-[#101725]"
        }`}
      >
        {title}
      </h2>
    </div>
  </Reveal>
);
